export interface EntityMention {
  text: string
  entity: string
}

export interface MeetingRecordingInsights {
  org_id: number
  video_id: number
  DATE?: EntityMention[]
  ORG?: EntityMention[]
  PERSON?: EntityMention[]
  PRODUCT?: EntityMention[]
  JOB_TITLE?: EntityMention[]
  MONEY?: EntityMention[]
}

export const getMentionCounts = (insights: MeetingRecordingInsights) => {
  const entities = new Map<string, number>()

  const incrementCount = (mention: EntityMention) =>
    entities.set(mention.entity, (entities.get(mention.entity) || 0) + 1)

  if (insights.PERSON) {
    insights.PERSON.forEach(incrementCount)
  }

  if (insights.JOB_TITLE) {
    insights.JOB_TITLE.forEach(incrementCount)
  }

  if (insights.ORG) {
    insights.ORG.forEach(incrementCount)
  }

  if (insights.PRODUCT) {
    insights.PRODUCT.forEach(incrementCount)
  }

  if (insights.DATE) {
    insights.DATE.forEach(incrementCount)
  }

  return entities
}

export const getMentionSummary = (insights?: MeetingRecordingInsights) => {
  if (insights) {
    const entityCounts = getMentionCounts(insights)

    const summary = []

    const getEntitySummary = (entity: string) => {
      const count = entityCounts.get(entity) || 0
      return `${entity}${count > 1 ? ` (${count})` : ''}`
    }

    if (insights.PERSON?.[0]) {
      summary.push(getEntitySummary(insights.PERSON?.[0]?.entity))
    }
    if (insights.JOB_TITLE?.[0]) {
      summary.push(getEntitySummary(insights.JOB_TITLE?.[0]?.entity))
    }
    if (insights.ORG?.[0]) {
      summary.push(getEntitySummary(insights.ORG?.[0]?.entity))
    }
    if (insights.PRODUCT?.[0]) {
      summary.push(getEntitySummary(insights.PRODUCT?.[0]?.entity))
    }
    if (insights.DATE?.[0]) {
      summary.push(getEntitySummary(insights.DATE?.[0]?.entity))
    }
    return summary
  }
}

export const getAllMentions = (insights?: MeetingRecordingInsights) => {
  if (insights) {
    const mentions: EntityMention[] = []
    if (insights.PERSON) {
      insights.PERSON.forEach(mention => mentions.push(mention))
    }

    if (insights.JOB_TITLE) {
      insights.JOB_TITLE.forEach(mention => mentions.push(mention))
    }

    if (insights.ORG) {
      insights.ORG.forEach(mention => mentions.push(mention))
    }

    if (insights.PRODUCT) {
      insights.PRODUCT.forEach(mention => mentions.push(mention))
    }

    if (insights.DATE) {
      insights.DATE.forEach(mention => mentions.push(mention))
    }

    return mentions
  } else {
    return []
  }
}
